import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, TextField, Typography, Tooltip } from "@material-ui/core";
import moment from "moment";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { FormControlLabel, FormGroup } from '@mui/material';

import { useDebouncedEffect } from "@hooks/debounceEffect";
import { useStore } from "@store/store";
import {
  ASSIGN_DRIVER_JOB_POOL,
  ASSIGN_DRIVER_JOB_POOL_FAILURE,
  ASSIGN_DRIVER_JOB_POOL_PROGRESS_FAILURE,
  ASSIGN_DRIVER_JOB_POOL_PROGRESS_SUCCESS,
  ASSIGN_DRIVER_JOB_POOL_SUCCESS,
  FETCH_JOB_POOL,
  FETCH_JOB_POOL_RELOAD_DATA,
  FETCH_JOB_POOL_FAILURE,
  FETCH_JOB_POOL_SUCCESS,
  FETCH_CARGO_WISE_JOB_POOL,
  FETCH_CARGO_WISE_JOB_POOL_SUCCESS,
  FETCH_CARGO_WISE_JOB_POOL_FAILURE,
  RESET_REDIRECTION,
  FETCH_JOB_POOL_INTERSTATE_RELOAD_DATA,
  ASSIGN_DRIVER_INTERSTATE_JOBS_NOT_STARTED_IN_POOL,
  ASSIGN_DRIVER_INTERSTATE_JOBS_NOT_STARTED_IN_POOL_FAILURE,
  ASSIGN_DRIVER_INTERSTATE_JOBS_NOT_STARTED_IN_POOL_SUCCESS,
  ASSIGN_DRIVER_INTERSTATE_JOBS_STARTED_IN_POOL,
  ASSIGN_DRIVER_INTERSTATE_JOBS_STARTED_IN_POOL_FAILURE,
  ASSIGN_DRIVER_INTERSTATE_JOBS_STARTED_IN_POOL_SUCCESS,
  FETCH_JOB_POOL_INTERSTATE,
  FETCH_JOB_POOL_INTERSTATE_FAILURE,
  FETCH_JOB_POOL_INTERSTATE_SUCCESS,
} from "@utils/actionTypes";

import { schema } from "@utils/schemas";
import validationSchema from "@utils/validationSchemas";
import IOSSwitch from '@components/iOSSwitch';
import Header from "@components/header";
import searchIcon from "@assets/images/search.svg";
import deployedCodeAccount from "@assets/images/deployed-code-account-white.svg";
import API from "@services/axios";
import {
  getFilter,
  removeFilter,
  setFilter,
  setInterstateMode,
  getInterstateMode
} from "@utils/commonFunctions";
import { rowsPerPageVal, sourceId } from "@utils/constant";
import { JobPoolListingStyle } from "./style";
import AssignDriverPopup from "./assign-driver-popup";
import AssignDriverHandoffPopup from "./assign-driver-handoff-popup";
import Filter from "./filter";
import TableListing from "./table-listing";
import CargoWiseJobTableListing from "./cargo-wise-job-table-list";

function JobPoolListing() {
  const classes = JobPoolListingStyle();
  const dashboardFilter = getFilter("jobDashboardFilter", true);
  const filter = getFilter("jobPoolFilter", true);
  const cargoVolumeFilter = getFilter("cargoVolume");
  let status = "";
  const [state, dispatch] = useStore();
  const [openFilter, setOpenFilter] = useState(false);
  const [dataTable, setDataTable] = useState({});
  const [selectedArray, setSelectedArray] = useState([]);
  const [selectedCityArray, setSelectedCityArray] = useState([]);
  const [primeJobIdArray, setPrimeJobIdArray] = useState([]);
  const [search, setSearch] = useState("");
  const [allowSearch, setAllowSearch] = useState(true);
  const [debounceSearch, setDebounceSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageVal);
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [openAssignDriverHandoffPopup, setOpenAssignDriverHandoffPopup] = useState(false);
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [period, setPeriod] = useState(
    filter ? filter?.period : dashboardFilter ? dashboardFilter.period : "",
  );
  const [openStartJob, setOpenStartJob] = useState(false);
  const [showStartJob, setShowStartJob] = useState(false);
  const [startJobPeriod, setStartJobPeriod] = useState(
    filter ? filter?.startJobPeriod : "",
  );
  const [isInterstateSwitch, setIsInterstateSwitch] = useState(!!JSON.parse(getInterstateMode("interstate")));
  const [isCargoWiseSwitch, setIsCargoWiseSwitch] = useState(false);
  const [isDisabledAssign, setIsDisabledAssign] = useState(false);
  const [eventId, setEventId] = useState("");
  const [actorDriverId, setActorDriverId] = useState("");
  const [swapType, setSwapType] = useState("");
  const [cloneSelectedArray, setCloneSelectedArray] = useState([]);

  status = state?.redirection?.jobStatusRedirection
    ? state?.common?.jobStatusData?.find(
      (item) => item.name === state?.redirection?.jobStatusRedirection,
    ).id
    : "";
  const [filterData, setFilterData] = useState({
    customer: filter
      ? filter?.customer
      : dashboardFilter
        ? dashboardFilter.customer
        : [],
    jobType: filter
      ? filter?.jobType
      : dashboardFilter
        ? dashboardFilter.jobType
        : [],
    jobStatus: filter ? filter.jobStatus : [],
    city: filter ? filter?.city : dashboardFilter ? dashboardFilter.city : [],
    cargoType: cargoVolumeFilter
      ? cargoVolumeFilter
      : filter
        ? filter.cargoType
        : dashboardFilter
          ? dashboardFilter.cargoType
          : [],
    cto: filter ? filter?.cto : dashboardFilter ? dashboardFilter.cto : [],
    startDate: filter
      ? filter?.startDate
      : dashboardFilter
        ? dashboardFilter.startDate
        : "",
    endDate: filter
      ? filter?.endDate
      : dashboardFilter
        ? dashboardFilter.endDate
        : "",
    createJobStartDate: filter ? filter?.createJobStartDate : "",
    createJobEndDate: filter ? filter?.createJobEndDate : "",
    pickUpCity: [],
    dropOffCity: [],
  });
  const [customDate, setCustomDate] = useState({
    startDate: null,
    endDate: null,
  });
  const [startJobCustomDate, setStartJobCustomDate] = useState({
    createJobStartDate: null,
    createJobEndDate: null,
  });

  // Handle Assign Driver Popup
  const [openDriverPopup, setOpenDriverPopup] = useState(false);
  const [error, setError] = useState("");
  const paramsGetJobPool = useMemo(() => {
    return {
      page: page + 1,
      size: rowsPerPage,
      ...(!!debounceSearch ? { search: debounceSearch } : {}),
      order: order !== "" ? order : "desc",
      orderBy: orderBy !== "" ? orderBy : "id",

      filter: {
        ...(!!filterData.jobType.length
          ? { jobTypeId: filterData.jobType }
          : {}),
        ...(!!filterData.jobStatus.length
          ? { jobStatusId: filterData.jobStatus }
          : {}),
        ...(!!filterData.city.length ? { cityId: filterData.city } : {}),
        ...(!!filterData.customer.length
          ? { customerId: filterData.customer }
          : {}),
        ...(!!filterData.cargoType.length
          ? { cargoTypeId: filterData.cargoType }
          : {}),
        ...(!!filterData.cto.length ? { ctoId: filterData.cto } : {}),
        ...(!!filterData.startDate
          ? { startDate: filterData.startDate }
          : !!customDate.startDate
            ? { startDate: filterData.startDate }
            : {}),
        ...(!!filterData.endDate
          ? { endDate: filterData.endDate }
          : !!customDate.endDate
            ? { endDate: filterData.endDate }
            : {}),
        ...(!!filterData.createJobStartDate
          ? { createJobStartDate: filterData.createJobStartDate }
          : !!startJobCustomDate.createJobStartDate
            ? { createJobStartDate: filterData.createJobStartDate }
            : {}),
        ...(!!filterData.createJobEndDate
          ? { createJobEndDate: filterData.createJobEndDate }
          : !!startJobCustomDate.createJobEndDate
            ? { createJobEndDate: filterData.createJobEndDate }
            : {})
      },
    };
  }, [
    page,
    rowsPerPage,
    debounceSearch,
    order,
    orderBy,
    filterData,
    customDate,
    startJobCustomDate,
  ]);
  const paramsGetCargoWiseJobPool = useMemo(() => {
    return {
      page: page + 1,
      size: rowsPerPage,
      ...(!!debounceSearch ? { search: debounceSearch } : {}),
      order: order !== "" ? order : "desc",
      orderBy: orderBy !== "" ? orderBy : "id",
    };
  }, [
    page,
    rowsPerPage,
    debounceSearch,
    order,
    orderBy,
  ]);

  const paramsGetInterstateJob = useMemo(() => {
    return {
      page: page + 1,
      size: rowsPerPage,
      ...(!!debounceSearch ? { search: debounceSearch } : {}),
      order: order !== "" ? order : "desc",
      orderBy: orderBy !== "" ? orderBy : "id",
      filter: {
        ...(!!filterData.jobStatus.length
          ? { jobStatusId: filterData.jobStatus }
          : {}),
        ...(!!filterData.customer.length
          ? { customerId: filterData.customer }
          : {}),
        ...(!!filterData.pickUpCity.length
          ? { pickUpCityId: filterData.pickUpCity }
          : {}),
        ...(state?.common?.truckId
          ? { startDate: state?.common?.truckId.startDate }
          : {}),
        ...(!!filterData.dropOffCity.length
          ? { dropOffCityId: filterData.dropOffCity }
          : {})
      },
    };
  }, [
    page,
    rowsPerPage,
    debounceSearch,
    order,
    orderBy,
    filterData,
    customDate,
    startJobCustomDate,
  ]);

  // API calling to get list of jobs Pool
  let getJobPool = useCallback((payload = paramsGetJobPool, needReloadData = false) => {
    let params = payload;
    dispatch({ type: needReloadData ? FETCH_JOB_POOL_RELOAD_DATA : FETCH_JOB_POOL });
    API.get("jobPool", { params })
      .then((response) => {
        dispatch({
          type: FETCH_JOB_POOL_SUCCESS,
          payload: response.data.data,
        });

        setDataTable(response?.data?.data?.rows);
      })
      .catch((error) => {
        dispatch({ type: FETCH_JOB_POOL_FAILURE, payload: error });
      });
  }, [paramsGetJobPool]);

  // API calling to get list of jobs Pool
  let getJobPoolInterState = useCallback((payload = paramsGetInterstateJob, needReloadData = false) => {
    dispatch({ type: needReloadData ? FETCH_JOB_POOL_INTERSTATE_RELOAD_DATA : FETCH_JOB_POOL_INTERSTATE });
    API.get("/interstateJobPool", { params: payload })
      .then((response) => {
        dispatch({
          type: FETCH_JOB_POOL_INTERSTATE_SUCCESS,
          payload: response.data.data,
        });

        setDataTable(response?.data?.data?.rows);
      })
      .catch((error) => {
        dispatch({ type: FETCH_JOB_POOL_INTERSTATE_FAILURE, payload: error });
      });
  }, [paramsGetInterstateJob]);

  let getCargoWiseJobPool = useCallback((payload = paramsGetCargoWiseJobPool) => {
    dispatch({ type: FETCH_CARGO_WISE_JOB_POOL });
    API.get("/jobPool/cargoWise", { params: payload })
      .then((response) => {
        dispatch({
          type: FETCH_CARGO_WISE_JOB_POOL_SUCCESS,
          payload: response.data.data,
        });

        setDataTable(response?.data?.data?.rows);
      })
      .catch((error) => {
        dispatch({ type: FETCH_CARGO_WISE_JOB_POOL_FAILURE, payload: error });
      });
  }, [paramsGetCargoWiseJobPool]);

  useEffect(() => {
    const totalJobs = selectedArray.length;
    const { assigningDriverProgressSuccess, assigningDriverProgressFailure } =
      state.jobPool;
    const processingJobs =
      assigningDriverProgressSuccess + assigningDriverProgressFailure;
    const hasAnyError = assigningDriverProgressFailure > 0;

    if (processingJobs > 0 && totalJobs === processingJobs) {
      handleAssignDriverPopupClose();
      if (hasAnyError) {
        if (assigningDriverProgressFailure === totalJobs) {
          dispatch({ type: ASSIGN_DRIVER_JOB_POOL_FAILURE, payload: {} });
          toast.error("Driver Assigned Unsuccessful");
        } else {
          dispatch({
            type: ASSIGN_DRIVER_JOB_POOL_SUCCESS,
            payload: {},
          });
          toast.warning("Driver Assigned Successfully with errors");
          if (isCargoWiseSwitch) {
            getCargoWiseJobPool();
          } else {
            getJobPool();
          }
        }
      } else {
        dispatch({
          type: ASSIGN_DRIVER_JOB_POOL_SUCCESS,
          payload: {},
        });
        toast.success("Driver Assigned Successfully");
        if (isCargoWiseSwitch) {
          getCargoWiseJobPool();
        } else {
          getJobPool();
        }
      }
      setPrimeJobIdArray([]);
      setSelectedArray([]);
      setCloneSelectedArray([]);
    }

  }, [
    state.jobPool.assigningDriverProgressSuccess,
    state.jobPool.assigningDriverProgressFailure,
  ]);

  useEffect(() => {
    if (state?.redirection?.jobStatusRedirection && status) {
      setFilterData({
        ...filterData,
        jobStatus: [
          state?.common?.jobStatusData?.find(
            (item) => item.name === state?.redirection?.jobStatusRedirection,
          ).id,
        ],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  useEffect(() => {
    setFilter("jobPoolFilter", { ...filterData, period, startJobPeriod }, true);
    return () =>
      dispatch({
        type: RESET_REDIRECTION,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    page,
    rowsPerPage,
    order,
    orderBy,
    state?.redirection?.filterRedirection,
  ]);

  useEffect(() => {
    handleReset();
  }, [isCargoWiseSwitch, isInterstateSwitch]);

  useEffect(() => {
    if (selectedArray.length > 0) {
      if (isInterstateSwitch) {
        const listIdsHandoffEvent = [];
        cloneSelectedArray.forEach(job => {
          listIdsHandoffEvent.push(job?.handoffJob?.driverVehicleTransferId);
        });
        if (new Set(listIdsHandoffEvent).size === 1) {
          setIsDisabledAssign(false);
        } else {
          setIsDisabledAssign(true);
        }
      } else {
        const cityMap = new Map();
        cloneSelectedArray.forEach(item => {
          cityMap.set(item?.cityId, item?.cityName);
        });
        setSelectedCityArray([...cityMap.keys()]);
      }
    } else {
      setIsDisabledAssign(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedArray]);

  const assignDriverFormik = useFormik({
    initialValues: schema.assignDriverSchema,
    validationSchema: validationSchema.assignDriverValidationSchema,
    onSubmit: (value) => {
      if (isInterstateSwitch) {
        const payload = {
          driverId: value.assignDriver,
          listJobIds: selectedArray,
        }
        dispatch({ type: ASSIGN_DRIVER_INTERSTATE_JOBS_NOT_STARTED_IN_POOL });
        API.put("interstateJobPool/assignDriver", payload)
          .then((response) => {
            dispatch({
              type: ASSIGN_DRIVER_INTERSTATE_JOBS_NOT_STARTED_IN_POOL_SUCCESS,
            });
            toast.success(response.data?.message ?? "Driver Assigned Successfully");
            setSelectedArray([]);
            setCloneSelectedArray([]);
            getJobPoolInterState();
          })
          .catch((error) => {
            dispatch({
              type: ASSIGN_DRIVER_INTERSTATE_JOBS_NOT_STARTED_IN_POOL_FAILURE,
            });
            toast.error(error.response?.data?.message ?? "Driver Assigned Unsuccessful");
          });
        handleAssignDriverPopupClose();
      } else {
        // handle assigning driver for cargo wise switch and local job pool
        dispatch({ type: ASSIGN_DRIVER_JOB_POOL });
        if (isCargoWiseSwitch) {
          for (const jobId of selectedArray) {
            if (primeJobIdArray.includes(jobId)) {
              assignConsolidatedJobToDriver(value.assignDriver, jobId);
            } else {
              assignLocalJobToDriver(value.assignDriver, jobId);
            }
          }
        } else {
          for (const jobId of selectedArray) {
            assignLocalJobToDriver(value.assignDriver, jobId);
          }
        }
      }
    },
  });

  // API calling to assign driver of handoff job
  const assignDriverHandoffFormik = useFormik({
    initialValues: schema.assignDriverHandoffInJobPoolSchema,
    validationSchema: validationSchema.assignDriverHandoffInJobPoolValidationSchema,
    onSubmit: (value) => {
      const listAllJobs = state.jobPool?.interstateJobsAssignData?.map(job => job.id) || [];
      const listJobIds = value.isFullAssignment ? listAllJobs : value.listJobs;
      const isFullAssignment = value.isFullAssignment || listAllJobs.length === value.listJobs.length;
      const payload = {
        driverId: value.assignDriver,
        listJobIds,
        swapType: value.swapType,
        driverVehicleTransferId: eventId,
        isFullAssignment
      };

      if (listAllJobs.length === 0 && value.isFullAssignment) {
        toast.error("Stale data: Job already handed off. Please refresh your list.");
        return;
      }

      dispatch({ type: ASSIGN_DRIVER_INTERSTATE_JOBS_STARTED_IN_POOL });
      API.put("interstateJobPool/assignDriverPendingJob", payload)
        .then((response) => {
          dispatch({
            type: ASSIGN_DRIVER_INTERSTATE_JOBS_STARTED_IN_POOL_SUCCESS,
          });
          toast.success(response.data?.message ?? "Driver Assigned Successfully");
          setSelectedArray([]);
          setCloneSelectedArray([]);
          getJobPoolInterState();
          handleAssignDriverHandoffPopupClose();
        })
        .catch((error) => {
          dispatch({
            type: ASSIGN_DRIVER_INTERSTATE_JOBS_STARTED_IN_POOL_FAILURE,
          });
          toast.error(error.response?.data?.message ?? "Driver Assigned Unsuccessful");
        });
    },
  });

  // API calling to assign local job to driver
  const assignLocalJobToDriver = (driverId, jobId) => {
    API.put(`jobPool/${jobId}/assignDriver`, {
      driverId,
    })
      .then((response) => {
        dispatch({
          type: ASSIGN_DRIVER_JOB_POOL_PROGRESS_SUCCESS,
        });
      })
      .catch((error) => {
        dispatch({
          type: ASSIGN_DRIVER_JOB_POOL_PROGRESS_FAILURE,
        });
      });
  };

  // API calling to assign consolidated job to driver
  const assignConsolidatedJobToDriver = (driverId, jobId) => {
    API.put(`jobPool/${jobId}/assignDriverConsolidatedJob`, {
      driverId,
    })
      .then((response) => {
        dispatch({
          type: ASSIGN_DRIVER_JOB_POOL_PROGRESS_SUCCESS,
        });
      })
      .catch((error) => {
        dispatch({
          type: ASSIGN_DRIVER_JOB_POOL_PROGRESS_FAILURE,
        });
        if (isCargoWiseSwitch) {
          toast.error(`One or more jobs in prime group P‑${jobId} cannot be assigned. Please check job statuses and try again.`);
        }
      });
  };

  const handleAssignPopupOpen = () => {
    if (isInterstateSwitch) {
      const job = cloneSelectedArray[0];
      if (job?.handoffJob?.driverVehicleTransferId) {
        setOpenAssignDriverHandoffPopup(true);
        setEventId(job?.handoffJob?.driverVehicleTransferId);
        setActorDriverId(job?.handoffJob?.actorDriverId);
        setSwapType(job?.handoffJob?.swapType);
      } else {
        handleAssignDriverPopupOpen();
      }
    } else {
      handleAssignDriverPopupOpen();
    }
  };

  const handleAssignDriverPopupOpen = () => {
    assignDriverFormik.values.assignDriver = "";
    setOpenDriverPopup(true);
  };

  const handleAssignDriverPopupClose = () => {
    setOpenDriverPopup(false);
    assignDriverFormik.touched.assignDriver = false;
    setError("");
    assignDriverFormik.handleReset();
  };

  // Debounce the search after 1 second
  useDebouncedEffect(
    () => {
      if (allowSearch) {
        setDebounceSearch(search);
        resetPagination();
        resetSorting();
        let payload = {
          page: 1,
          size: rowsPerPageVal,
          order: "desc",
          orderBy: "id",
        };
        if (isCargoWiseSwitch) {
          delete paramsGetCargoWiseJobPool?.search;
          payload = {
            ...paramsGetCargoWiseJobPool,
            ...payload,
            ...(!!search ? { search: search } : {})
          };
          getCargoWiseJobPool(payload);
        } else {
          if (isInterstateSwitch) { // For Interstate
            delete paramsGetInterstateJob?.search;
            payload = {
              ...paramsGetInterstateJob,
              ...payload,
              ...(!!search ? { search: search } : {})
            };
            getJobPoolInterState(payload, false);
          } else { // For Local
            delete paramsGetJobPool?.search;
            payload = {
              ...paramsGetJobPool,
              ...payload,
              ...(!!search ? { search: search } : {})
            };
            getJobPool(payload, false);
          }
        }
      }
    },
    1000,
    [search],
  );

  const openFilterPopup = () => {
    document.body.classList.toggle("open-filter");
    setOpenFilter(true);
  };

  const closeFilterPopup = () => {
    document.body.classList.remove("open-filter");
    setOpenFilter(false);
  };

  const handleReset = () => {
    removeFilter("jobPoolFilter");
    removeFilter("jobDashboardFilter");
    removeFilter("cargoVolume");
    document.body.classList.remove("open-filter");
    setShow(false);
    setPeriod("");
    setShowStartJob(false);
    setStartJobPeriod("");
    setFilterData({
      jobStatus: [],
      customer: [],
      jobType: [],
      city: [],
      cargoType: [],
      cto: [],
      startDate: null,
      endDate: null,
      createJobStartDate: null,
      createJobEndDate: null,
      pickUpCity: [],
      dropOffCity: [],
    });
    setCustomDate({
      startDate: null,
      endDate: null,
    });
    setStartJobCustomDate({
      createJobStartDate: null,
      createJobEndDate: null,
    });
    setSelectedArray([]);
    setCloneSelectedArray([]);
    setPrimeJobIdArray([]);
    resetPagination();
    resetSorting();
    let payload = {
      page: 1,
      size: rowsPerPageVal,
      order: "desc",
      orderBy: "id",
    };
    if (isCargoWiseSwitch) {
      payload = {
        ...paramsGetCargoWiseJobPool,
        ...payload,
      };
      getCargoWiseJobPool(payload);
    } else {
      if (isInterstateSwitch) { // For Interstate
        payload = {
          ...paramsGetInterstateJob,
          ...payload,
        };
        getJobPoolInterState(payload, false);
      } else { // For Local
        payload = {
          ...paramsGetJobPool,
          ...payload,
        };
        getJobPool(payload, false);
      }
    }
  };

  const handleStartJobCustomDateSubmit = () => {
    setOpenStartJob(false);
    setShowStartJob(true);
    setFilterData({
      ...filterData,
      createJobStartDate: startJobCustomDate.createJobStartDate,
      createJobEndDate: startJobCustomDate.createJobEndDate,
    });
    setStartJobPeriod(7);
    resetPagination();
    resetSorting();
    let payload = {
      page: 1,
      size: rowsPerPageVal,
      order: "desc",
      orderBy: "id",
    };
    if (isInterstateSwitch) { // For Interstate
      payload = {
        ...paramsGetInterstateJob,
        ...payload,
      };
      getJobPoolInterState(payload, false);
    } else { // For Local
      payload = {
        ...paramsGetJobPool,
        ...payload,
        filter: {
          ...paramsGetJobPool.filter,
          createJobStartDate: startJobCustomDate.createJobStartDate,
          createJobEndDate: startJobCustomDate.createJobEndDate,
        }
      };
      getJobPool(payload, false);
    }
  };

  const handleFilter = (event) => {
    const { name, value } = event.target;
    setFilterData({
      ...filterData,
      [name]: value,
    });

    setFilter("jobPoolFilter", { ...filterData, period, startJobPeriod }, true);
    resetPagination();
    resetSorting();
    let nameParam = {};
    nameParam = value?.length
      ? { [`${name}Id`]: value }
      : !isInterstateSwitch
        ? delete paramsGetJobPool.filter[`${name}Id`]
        : delete paramsGetInterstateJob.filter[`${name}Id`];
    let payload = {
      page: 1,
      size: rowsPerPageVal,
      order: "desc",
      orderBy: "id",
    };
    if (isInterstateSwitch) { // For Interstate
      payload = {
        ...paramsGetInterstateJob,
        ...payload,
        filter: {
          ...paramsGetInterstateJob.filter,
          ...nameParam
        }
      };
      getJobPoolInterState(payload, false);
    } else { // For Local
      payload = {
        ...paramsGetJobPool,
        ...payload,
        filter: {
          ...paramsGetJobPool.filter,
          ...nameParam
        }
      };
      getJobPool(payload, false);
    }
  };

  const handleSearch = (event) => {
    setSearch(event.target.value.trimStart());
    setAllowSearch(true);
  };

  const handleSorting = (event, property) => {
    const isAsc = orderBy === property.sortTitle && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property.sortTitle);
    resetPagination();
    let payload = {
      page: 1,
      size: rowsPerPageVal,
      order: isAsc ? "desc" : "asc",
      orderBy: property.sortTitle,
    };
    if (isCargoWiseSwitch) {
      payload = {
        ...paramsGetCargoWiseJobPool,
        ...payload,
      };
      getCargoWiseJobPool(payload);
    } else {
      if (isInterstateSwitch) { // For Interstate
        payload = {
          ...paramsGetInterstateJob,
          ...payload,
        };
        getJobPoolInterState(payload, false);

      } else { // For Local
        payload = {
          ...paramsGetJobPool,
          ...payload,
        };
        getJobPool(payload, false);
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);

    let payload = {
      page: newPage + 1,
    };
    if (isCargoWiseSwitch) {
      payload = {
        ...paramsGetCargoWiseJobPool,
        ...payload,
      };
      getCargoWiseJobPool(payload);
    } else {
      if (isInterstateSwitch) { // For Interstate
        payload = {
          ...paramsGetInterstateJob,
          ...payload,
        };
        getJobPoolInterState(payload, false);

      } else { // For Local
        payload = {
          ...paramsGetJobPool,
          ...payload,
        };
        getJobPool(payload, false);
      }
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);

    let payload = {
      page: 1,
      size: parseInt(event.target.value, 10),
    };
    if (isCargoWiseSwitch) {
      payload = {
        ...paramsGetCargoWiseJobPool,
        ...payload,
      };
      getCargoWiseJobPool(payload);
    } else {
      if (isInterstateSwitch) { // For Interstate
        payload = {
          ...paramsGetInterstateJob,
          ...payload,
        };
        getJobPoolInterState(payload, false);

      } else { // For Local
        payload = {
          ...paramsGetJobPool,
          ...payload,
        };
        getJobPool(payload, false);
      }
    }
  };

  // To handle checkboxes from listing
  const handleChange = (item) => {
    let id = item.id;
    if (isCargoWiseSwitch) {
      if (item?.primeConsolidatedJobs?.length > 0) {
        setPrimeJobIdArray((prevPrimeJobIdArray) =>
          prevPrimeJobIdArray.includes(id)
            ? prevPrimeJobIdArray.filter((jobId) => jobId !== id)
            : [...prevPrimeJobIdArray, id]
        );
      }
    }
    const selectedIndex = selectedArray.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedArray, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedArray.slice(1));
    } else if (selectedIndex === selectedArray.length - 1) {
      newSelected = newSelected.concat(selectedArray.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedArray.slice(0, selectedIndex),
        selectedArray.slice(selectedIndex + 1),
      );
    }
    setSelectedArray(newSelected);
    setCloneSelectedArray((prev) => {
      const map = new Map(prev.map(j => [j.id, j]));
      if (selectedIndex === -1) {
        map.set(item.id, {
          id: item.id,
          cityId: item.cities?.id,
          cityName: item.cities?.name,
          handoffJob: {
            driverVehicleTransferId: item?.handoffJob?.driverVehicleTransferId,
            actorDriverId: item?.handoffJob?.actorDriverId,
            swapType: item?.handoffJob?.swapType,
          }
        });
      } else {
        map.delete(item.id);
      }
      return Array.from(map.values());
    });
  };

  // To handle main checkbox
  const handleMainChangeCheckBox = (e) => {
    let rows = dataTable || [];

    if (!isCargoWiseSwitch && !isInterstateSwitch) {
      rows = rows.filter(item => item?.sources?.id !== sourceId.CARGO_WISE);
    }
    const rowIds = rows.map(item => item.id);

    if (e.target.checked) {
      setSelectedArray(prev => {
        const set = new Set(prev);
        rowIds.forEach(id => set.add(id));
        return Array.from(set);
      });

      setCloneSelectedArray(prev => {
        const map = new Map(prev.map(j => [j.id, j]));
        rows.forEach(item => {
          if (!map.has(item.id)) {
            map.set(item.id, {
              id: item.id,
              cityId: item.cities?.id,
              cityName: item.cities?.name,
              handoffJob: {
                driverVehicleTransferId: item?.handoffJob?.driverVehicleTransferId,
                actorDriverId: item?.handoffJob?.actorDriverId,
                swapType: item?.handoffJob?.swapType,
              }
            });
          }
        });
        return Array.from(map.values());
      });

      if (isCargoWiseSwitch) {
        const primeIds = rows
        .filter(item => item?.primeConsolidatedJobs?.length > 0)
        .map(item => item.id);

        // save all prime job id in array to check before assign driver
        setPrimeJobIdArray(prev => {
          const set = new Set(prev);
          primeIds.forEach(id => set.add(id));
          return Array.from(set);
        });
      }
    } else {
      const removeSet = new Set(rowIds);
      setSelectedArray(prev =>
        prev.filter(id => !removeSet.has(id))
      );
      setCloneSelectedArray(prev =>
        prev.filter(job => !removeSet.has(job.id))
      );
      setPrimeJobIdArray(prev =>
        prev.filter(id => !removeSet.has(id))
      );
    }
  };

  const handleStartJobPeriodChange = (event, type) => {
    const { value } = event.target;
    setStartJobPeriod(value);
    setShowStartJob(false);
    if (!openFilter) {
      setFilter(
        "jobPoolFilter",
        {
          ...filterData,
          startJobPeriod: value,
        },
        true,
      );
    }
    if (value === 7 || type === true) {
      setOpenStartJob(true);
    } else {
      let createJobStartDate;
      let createJobEndDate;
      const newDate = new Date();
      if (value === "") {
        setFilterData({
          ...filterData,
          createJobStartDate: null,
          createJobEndDate: null,
        });
        setStartJobCustomDate({
          createJobStartDate: null,
          createJobEndDate: null,
        });
      } else if (value === 1) {
        createJobStartDate = moment(newDate).format("YYYY-MM-DD");
        createJobEndDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          createJobStartDate,
          createJobEndDate,
        });
      } else if (value === 2) {
        createJobStartDate = moment(newDate).subtract(1, "day")
          .format("YYYY-MM-DD");
        createJobEndDate = moment(newDate).subtract(1, "day")
          .format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          createJobStartDate,
          createJobEndDate,
        });
      } else if (value === 3) {
        createJobStartDate = moment(newDate).subtract(3, "day").format("YYYY-MM-DD");
        createJobEndDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          createJobStartDate,
          createJobEndDate,
        });
      } else if (value === 4) {
        createJobStartDate = moment(newDate).subtract(7, "day").format("YYYY-MM-DD");
        createJobEndDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          createJobStartDate,
          createJobEndDate,
        });
      } else if (value === 5) {
        createJobStartDate = moment(newDate).subtract(14, "day").format("YYYY-MM-DD");
        createJobEndDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          createJobStartDate,
          createJobEndDate,
        });
      } else if (value === 6) {
        createJobStartDate = moment(newDate).subtract(30, "day").format("YYYY-MM-DD");
        createJobEndDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          createJobStartDate,
          createJobEndDate,
        });
      }
      resetPagination();
      resetSorting();
      let payload = {
        page: 1,
        size: rowsPerPageVal,
        order: "desc",
        orderBy: "id",
      };
      if (isInterstateSwitch) { // For Interstate
        payload = {
          ...paramsGetInterstateJob,
          ...payload,
        };
        getJobPoolInterState(payload, false);
      } else { // For Local
        delete paramsGetJobPool?.filter?.createJobStartDate;
        delete paramsGetJobPool?.filter?.createJobEndDate;
        payload = {
          ...paramsGetJobPool,
          ...payload,
          filter: {
            ...paramsGetJobPool.filter,
            createJobStartDate,
            createJobEndDate,
          }
        };
        getJobPool(payload, false);
      }
    }
  };

  const handlePeriodChange = (event, type) => {
    const { value } = event.target;
    setPeriod(value);
    setShow(false);
    if (!openFilter) {
      setFilter(
        "jobPoolFilter",
        {
          ...filterData,
          period: value,
        },
        true,
      );
    }
    if (value === 7 || type === true) {
      setOpen(true);
    } else {
      let startDate;
      let endDate;
      const newDate = new Date();
      if (value === "") {
        setFilterData({
          ...filterData,
          startDate: null,
          endDate: null,
        });
        setCustomDate({
          startDate: null,
          endDate: null,
        });
      } else if (value === 1) {
        startDate = moment(newDate).format("YYYY-MM-DD");
        endDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startDate,
          endDate,
        });
      } else if (value === 2) {
        startDate = moment(newDate).subtract(1, "day").format("YYYY-MM-DD");
        endDate = moment(newDate).subtract(1, "day").format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startDate,
          endDate,
        });
      } else if (value === 3) {
        startDate = moment(newDate).subtract(3, "day").format("YYYY-MM-DD");
        endDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startDate,
          endDate,
        });
      } else if (value === 4) {
        startDate = moment(newDate).subtract(7, "day").format("YYYY-MM-DD");
        endDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startDate,
          endDate,
        });
      } else if (value === 5) {
        startDate = moment(newDate).subtract(14, "day").format("YYYY-MM-DD");
        endDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startDate,
          endDate,
        });
      } else if (value === 6) {
        startDate = moment(newDate).subtract(30, "day").format("YYYY-MM-DD");
        endDate = moment(newDate).format("YYYY-MM-DD");
        setFilterData({
          ...filterData,
          startDate,
          endDate,
        });
      }
      resetPagination();
      resetSorting();
      let payload = {
        page: 1,
        size: rowsPerPageVal,
        order: "desc",
        orderBy: "id",
      };
      if (isInterstateSwitch) { // For Interstate
        payload = {
          ...paramsGetInterstateJob,
          ...payload,
        };
        getJobPoolInterState(payload, false);
      } else { // For Local
        delete paramsGetJobPool?.filter?.startDate;
        delete paramsGetJobPool?.filter?.endDate;
        payload = {
          ...paramsGetJobPool,
          ...payload,
          filter: {
            ...paramsGetJobPool.filter,
            startDate,
            endDate,
          }
        };
        getJobPool(payload, false);
      }
    }
  };

  const handleClose = () => {
    setPeriod("");
    setOpen(false);
    setCustomDate({
      startDate: null,
      endDate: null,
    });
  };

  const handleStartJobClose = () => {
    setStartJobPeriod("");
    setOpenStartJob(false);
    setStartJobCustomDate({
      createJobStartDate: null,
      createJobEndDate: null,
    });
  };

  const handleCustomChange = (event, type) => {
    if (type === "startDate" || type === "endDate") {
      setCustomDate({
        ...customDate,
        [type]: moment(event).format("YYYY-MM-DD"),
      });
    } else {
      const { name, value } = event.target;
      setCustomDate({
        ...customDate,
        [name]: value,
      });
    }
  };

  const handleStartJobCustomChange = (event, type) => {
    if (type === "createJobStartDate" || type === "createJobEndDate") {
      setStartJobCustomDate({
        ...startJobCustomDate,
        [type]: moment(event).format("YYYY-MM-DD"),
      });
    } else {
      const { name, value } = event.target;
      setStartJobCustomDate({
        ...startJobCustomDate,
        [name]: value,
      });
    }
  };

  const handleSwitchChange = (event) => {
    setIsInterstateSwitch(event.target.checked);
    setAllowSearch(false);
    setIsCargoWiseSwitch(false);
    if (!event.target.checked) { // For Local
      delete paramsGetJobPool?.search;
      delete paramsGetJobPool?.order;
      delete paramsGetJobPool?.orderBy;
    } else { // For Interstate
      delete paramsGetInterstateJob?.search;
      delete paramsGetInterstateJob?.order;
      delete paramsGetInterstateJob?.orderBy;
    }
    setSearch('');
    paramsGetInterstateJob.isInterstate = event.target.checked;
    setInterstateMode("interstate", event.target.checked);
    setDebounceSearch("");
  }

  const handleCargoWiseSwitchChange = () => {
    setIsCargoWiseSwitch(!isCargoWiseSwitch);
    setAllowSearch(false);
    setIsInterstateSwitch(false);
    setInterstateMode("interstate", false);
    setSearch('');
    setDebounceSearch("");
  }

  const handleAssignDriverHandoffPopupClose = () => {
    setOpenAssignDriverHandoffPopup(false);
    assignDriverHandoffFormik.handleReset();
    setError("");
    setEventId("");
    setActorDriverId("");
    setSwapType("");
  };

  const resetPagination = () => {
    setPage(0);
    setRowsPerPage(rowsPerPageVal);
  };

  const resetSorting = () => {
    setOrder("");
    setOrderBy("");
  };

  return (
    <>
      <Header />
      <div className={classes.JobPoolListingWrapper}>
        <div className="dashboard-page wrapper">
          <div className="inner-page">
            <div className="title-panel">
              <Typography variant="h1">Job Pool</Typography>
            </div>
            <div className={classes.innerPageTopBlock}>
              <div className="left-block">
                <FormGroup>
                  <Typography variant="h6">Interstate</Typography>
                  <FormControlLabel
                    control={<IOSSwitch checked={isInterstateSwitch} onChange={handleSwitchChange} />}
                  />
                </FormGroup>
                <span className="separate-func"></span>
                <FormGroup>
                  <Typography variant="h6">CargoWise</Typography>
                  <FormControlLabel
                    control={<IOSSwitch checked={isCargoWiseSwitch} onClick={handleCargoWiseSwitchChange} />}
                  />
                </FormGroup>
              </div>

              <div className="right-block">
                <div className="right-block-inner">
                  <div className="search-wrapper">
                    <div className="form-group">
                      <TextField
                        id="search-request"
                        placeholder={isCargoWiseSwitch ? "Search by job ID" : "Search by ID/AWB/Cons./ULD/Customer"}
                        variant="outlined"
                        type="search"
                        InputProps={{
                          endAdornment: <img src={searchIcon} alt="Search"/>,
                        }}
                        value={search}
                        onChange={handleSearch}
                      />
                    </div>
                  </div>
                  <Tooltip
                    title={isInterstateSwitch ? "You can assign any single job. To assign multiple jobs, please make sure they are all not started or from the same handoff." : "Select at least one job to enable the Assign button."}
                    disableHoverListener={(isInterstateSwitch ? !isDisabledAssign : (selectedCityArray.length === 1 && selectedArray.length !== 0))}
                  >
                    <div className="button_holder">
                      <div className="btn-wrapper">
                        <Button
                          color="inherit"
                          variant="contained"
                          disableElevation
                          className="primary-btn orange-btn"
                          onClick={() => handleAssignPopupOpen()}
                          disabled={isInterstateSwitch ? isDisabledAssign : (selectedCityArray.length !== 1 || selectedArray.length === 0)}
                        >
                          <img src={deployedCodeAccount} alt="Assign"/>
                          Assign
                        </Button>
                      </div>
                    </div>
                  </Tooltip>
                  {!isCargoWiseSwitch && (
                    <div className="dropdown_wrapper1">
                      <div className={classes.filter}>
                        <Filter
                          handleFilter={handleFilter}
                          filterData={filterData}
                          openFilterPopup={openFilterPopup}
                          closeFilterPopup={closeFilterPopup}
                          handleClose={handleClose}
                          handlePeriodChange={handlePeriodChange}
                          handleCustomChange={handleCustomChange}
                          period={period}
                          open={open}
                          show={show}
                          customDate={customDate}
                          startJobPeriod={startJobPeriod}
                          openStartJob={openStartJob}
                          showStartJob={showStartJob}
                          startJobCustomDate={startJobCustomDate}
                          handleStartJobPeriodChange={handleStartJobPeriodChange}
                          handleStartJobCustomChange={handleStartJobCustomChange}
                          handleStartJobCustomDateSubmit={
                            handleStartJobCustomDateSubmit
                          }
                          handleStartJobClose={handleStartJobClose}
                          handleReset={handleReset}
                          openFilter={openFilter}
                          isInterstate={isInterstateSwitch}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {isCargoWiseSwitch ? (
              <CargoWiseJobTableListing
                handleChange={handleChange}
                handleMainChange={handleMainChangeCheckBox}
                selectedArray={selectedArray}
                page={page}
                handleChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                handleSorting={(e, property) => handleSorting(e, property)}
                orderBy={orderBy}
                order={order}
                isCargoWise={isCargoWiseSwitch}
              />
            ) : (
              <TableListing
                handleChange={handleChange}
                handleMainChange={handleMainChangeCheckBox}
                selectedArray={selectedArray}
                page={page}
                handleChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                handleSorting={(e, property) => handleSorting(e, property)}
                orderBy={orderBy}
                order={order}
                isInterstate={isInterstateSwitch}
              />
            )}

            <AssignDriverPopup
              handleClose={handleAssignDriverPopupClose}
              open={openDriverPopup}
              error={error}
              cityId={selectedCityArray[0]}
              formik={assignDriverFormik}
              isInterstate={isInterstateSwitch}
            />

            <AssignDriverHandoffPopup
              handleClose={handleAssignDriverHandoffPopupClose}
              open={openAssignDriverHandoffPopup}
              formik={assignDriverHandoffFormik}
              listJobIds={selectedArray}
              eventId={eventId}
              actorDriverId={actorDriverId}
              swapType={swapType}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default JobPoolListing;
